import axios from 'axios';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { initialize } from 'redux-form';

const API = `${consts.API_URL}/fornecedor`;

export const FORNECEDOR_MODO_TELA = 'FORNECEDOR_MODO_TELA';
export const FORNECEDOR_SET_AGUARDANDO = 'FORNECEDOR_SET_AGUARDANDO';
export const FORNECEDOR_LISTADO = 'FORNECEDOR_LISTADO';

export function setModoTela(modo, registro = {}) {
    return {
        type: FORNECEDOR_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: FORNECEDOR_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('fornecedorForm', registro)
    ];
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API);

            dispatch({
                type: FORNECEDOR_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            if (!registro.id) {
                await axios.post(API, {
                    ...registro
                });
            } else {
                await axios.put(API, {
                    ...registro
                });
            }

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}